import React, { memo } from "react";
import { Button, Modal } from "antd";
import { defaultPopupValue } from "../HomePage";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const IsExistedPatientModal = ({
  isOpenExistedPatientAlert,
  setIsOpenExistedPatientAlert,
  onCreatePatientRegister,
}) => {
  const theme = localStorage.getItem("default-theme");

  const onClosePopup = () => {
    setIsOpenExistedPatientAlert({
      existedPatientDetails: defaultPopupValue,
      isOpenExistedPatientPopup: false,
    });
  };

  const { patient_full_name, patientDOB, patientID } =
    isOpenExistedPatientAlert.existedPatientDetails;

  return (
    <Modal
      centered
      open={isOpenExistedPatientAlert.isOpenExistedPatientPopup}
      className={`reminderModal ivf_id_alert_modal theme-${theme}`}
      maskClosable={false}
    >
      <p>
        <b>Patient Full Name</b> : {patient_full_name}
      </p>
      <p>
        <b>Patient DOB</b> : {formatDateToDDMMYYYY(patientDOB)}
      </p>
      <p>
        <b>Patient ID</b> : {patientID}
      </p>
      <p className="fw-bold">
        If you want to proceed and create a new patient account, please click
        the "Yes" button
      </p>
      <div className="d-flex justify-content-center gap-2">
        <Button
          className="btn_gray close_btn"
          onClick={() => {
            onClosePopup();
            onCreatePatientRegister();
          }}
        >
          Yes
        </Button>
        <Button className="btn_gray close_btn" onClick={onClosePopup}>
          No
        </Button>
      </div>
    </Modal>
  );
};

export default memo(IsExistedPatientModal);
